import {config} from './config'

console.log(`L  €  X  3  R  .  $`)
console.log(`ʌ     ɪ     f     ə`)
if (config.prod) {
    console.log = () => {}
    console.info = () => {}
    console.debug = () => {}
}
